import { axiosInstance } from "../../../api/axios";

const endpoint = (groupCode, projectCode, linkId) =>
  `/risk/${encodeURIComponent(groupCode)}/${encodeURIComponent(
    projectCode
  )}/machine-safety/${encodeURIComponent(linkId)}`;

export const getMachineSafetyDetail = async ({
  groupCode,
  projectCode,
  linkId,
  date,
}) => {
  const response = await axiosInstance.get(
    endpoint(groupCode, projectCode, linkId),
    { params: date ? { date } : undefined }
  );
  return response.data;
};

export const getMachineSafetyHistory = async ({
  groupCode,
  projectCode,
  linkId,
  limit = 300,
}) => {
  const response = await axiosInstance.get(
    `${endpoint(groupCode, projectCode, linkId)}/evaluations`,
    { params: { limit } }
  );
  return response.data;
};

export const resolveMachineSafetyFileUrl = (value) => {
  if (!value) return "";
  const url = String(value);
  if (/^(https?:)?\/\//.test(url) || url.startsWith("data:") || url.startsWith("blob:")) {
    return url;
  }
  if (url.startsWith("/backend/")) return url;
  return `${axiosInstance.defaults.baseURL || ""}${url.startsWith("/") ? "" : "/"}${url}`;
};
